<template>
  <div>
    <div v-if="url">
      <span class="label label-success" v-if="status">Active</span>
      <span class="label label-danger" v-else>Inactive</span>
      <a :href="url" class="ml-1">{{ firstName }} {{ lastName }}</a> - created at: {{ createdAt }}
    </div>

    <adjuster-user-link-modal
      title="Add CIMS User"
      modal-id="link-user-from-button-modal"
      :first-name="this.firstName"
      :last-name="this.lastName"
      :match-user-url="this.matchUserUrl"
      :link-user-url="this.linkUserUrl"
      :create-user-url="this.createUserUrl">

      <button v-if="!url"
        class="btn btn-primary"
        :class="buttonClass"
        v-modal="'link-user-from-button-modal'">

        <i class="fa fa-fw fa-edit"></i> Add User
      </button>
    </adjuster-user-link-modal>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'pinia'
  import { useAdjusterToUserDataStore } from '../../stores/adjusterToUserData'

  export default {

    created() {
      this.setData({
        'url': this.userUrl,
        'createdAt': this.userCreatedAt,
        'firstName': this.userFirstName,
        'lastName': this.userLastName,
        'status': this.userStatus,
      });
    },

    props: {
      userFirstName: {
        type: String,
        default: ''
      },
      userLastName: {
        type: String,
        default: ''
      },
      // Datetime when user was created from adjuster.
      userCreatedAt: {
        type: String,
        default: ''
      },
      userUrl: {
        type: String,
        default: ''
      },
      userStatus: {
        type: Boolean,
        default: false
      },
      buttonClass: {
        type: [Array, String],
        default: () => {return [];}
      },
      // Match user loader URL.
      matchUserUrl: {
        type: String,
        default: ''
      },
      // Link user URL.
      linkUserUrl: {
        type: String,
        default: ''
      },
      // Create user URL.
      createUserUrl: {
        type: String,
        required: true
      },
    },

    computed: {
      ...mapState(useAdjusterToUserDataStore, ['url', 'createdAt', 'firstName', 'lastName', 'status'])
    },

    methods: {
      ...mapActions(useAdjusterToUserDataStore, ['setData']),
    }
  }
</script>
